<template>
 <on-click-outside :do="closeSearch">
  <div class="relative">
    <div class="w-full" >
      <div class="flex flex-col">
        <p class="pb-1 text-class text-additional-text cursor-pointer"
           style="color: #333;"
           :style="defaultFont ? 'font-size: 0.65rem; padding-left: .25rem; padding-right: .25rem;': ''"
        >Название команды</p>
        <div class="flex flex-row items-center" @click.prevent="toggleSearchCitySelect">
          <p class="pb-1 text-class text-main-text cursor-pointer"
             style="color: #333;"
             :style="defaultFont ? 'padding-left: .25rem; padding-right: .25rem;': ''"
          >{{selectedOption}}</p>
          <font-awesome-icon :icon="['far', 'angle-down']" size="1x" :class="rotateArrow" fixed-width
                             class="arrow text-main-text cursor-pointer -mr-3"
          ></font-awesome-icon>
        </div>
      </div>
      <div class="absolute rounded-lg bg-white shadow-lg mt-2 w-full" style="z-index: 100"  v-if="searchSelect !== false" >
        <div >
          <input class="border border-additional-text rounded p-2 w-full" style="outline: none" type="text" v-model="search">
          <div style="height: 160px" class="flex flex-col overflow-y-scroll mt-1">
            <p v-if="options.length === 0 && !spinner" class="py-2 px-2 rounded">Нет подходящей команды</p>
            <p v-if="options.length > 0" v-for="(filtered, key) in options" :key="key"
               class="hover:bg-select-box-brand-light hover:text-white py-2 px-2 rounded" @click.prevent="setParam(filtered)">{{filtered}}</p>
            <img v-if="spinner" class="absolute spinner" src="../../../assets/spinners/tail-spin-registration.svg">
          </div>
        </div>
        </div>
    </div>
  </div>
 </on-click-outside>
</template>

<script>
import OnClickOutside from '@/views/OnClickOutside';
import SelectBox from '@/views/partners/selectbox';
import debounce from 'lodash/debounce';
import clone from 'lodash/cloneDeep';

export default {
  name: 'selectTeam',
  components: { OnClickOutside, SelectBox },
  props: {
    options: {
      type: Array,
      default: [],
    },
    isNewRegistration: {
      type: Boolean,
      default: false,
    },
    teamsLoaded: {
      type: Boolean,
      default: false,
    },
    defaultFont: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      searchSelect: false,
      cityAdder: false,
      search: '',
      selected_filter: '',
      param: '',
      spinner: false,
    };
  },
  created() {
    if (this.options.length < 1 && this.isNewRegistration) {
      this.spinner = true;
    }
    this.setUpTeamsSelector();
  },
  methods: {
    addCity() {
      this.cityAdder = true;
    },
    toggleSearchCitySelect() {
      this.searchSelect = !this.searchSelect;
    },
    setUpTeamsSelector() {
      window.addEventListener('mouseup', function (event) {
        const team_selector = document.getElementById('team_selector');
        if (event.target != team_selector && event.target.parentNode != team_selector) {
          this.searchSelect = false;
        }
      });
    },
    closeSearch() {
      if (this.searchSelect) {
        this.searchSelect = false;
      }
    },
    setParam(filtered) {
      this.param = filtered;
      this.searchSelect = false;
      const teamId = this.options.findIndex(option => option === filtered);
      this.$emit('input', teamId);
    },
    searchTeam: debounce(function (search) {
      this.spinner = true;
      this.$emit('searched', search);
    }, 1000),
  },
  computed: {
    selectedOption() {
      if (!this.param) {
        return 'Выбор команды';
      } else if (this.param) {
        return this.param;
      }
    },
    rotateArrow() {
      return !this.searchSelect ? '' : 'rotate-arrow';
    },
  },
  watch: {
    teamsLoaded() {
      if (this.teamsLoaded && this.isNewRegistration) {
        this.spinner = false;
      }
    },
    search(val) {
      this.searchTeam(val);
    },
  },
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 8px;
  height: 4px;

}
::-webkit-scrollbar-thumb {
  opacity: 0.3;
  border: 2px solid transparent;
  background-clip: padding-box;
  -webkit-border-radius: 7px;
  background-color: #979797;
  -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
}
::-webkit-scrollbar-button {
  width: 0;
  height: 0;
  display: none;
}
::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar-track-piece
{
  background-color: transparent;
  -webkit-border-radius: 6px;
}
.text-class {
  font-weight: 700;
  font-size: .875rem;
  color: #979797;
}
.arrow {
  transition: 0.5s all;
}

.rotate-arrow {
  transform: rotate(180deg);
}
.spinner {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  fill: #4a0045;
}
</style>
